import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injectable, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import * as Sentry from '@sentry/browser';

if (false) {
    Sentry.init({
        dsn: 'https://1525f615cde74ab2ac7812ac687c5984@sentry.io/1300410',
        // beforeSend(event) {
        //     // Check if it is an exception, if so, show the report dialog
        //     if (event.exception) {
        //         Sentry.showReportDialog({
        //             lang: 'it',
        //             title: 'Sembra che qualcosa sia andato storto',
        //             subtitle: 'Il nostro team sta venendo notificato.',
        //             subtitle2: 'Se ti va di aiutare, dicci cosa è accaduto.',
        //             labelName: 'Nome',
        //             labelEmail: 'Email',
        //             labelComments: "Cos'è accaduto?",
        //             labelClose: 'Chiudi',
        //             labelSubmit: 'Invia',
        //             errorGeneric:
        //                 "Si è verificato un errore sconosciuto durante l'invio del report. Per favore riprova.",
        //             errorFormEntry:
        //                 'Alcuni campi non erano validi. Correggi gli errori e riprova.',
        //             successMessage: 'Il tuo feedback è stato inviato. Grazie!',
        //         });
        //     }
        //     return event;
        // },
    });
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    constructor() {}
    handleError(error) {
        Sentry.captureException(error.originalError || error);

        throw error;
    }
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
        }),
    ],
    providers: [
        environment.production
            ? { provide: ErrorHandler, useClass: SentryErrorHandler }
            : [],
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
